// removed by extract-text-webpack-plugin
module.exports = {"text800":"_2ST5onrJ6oAbXlSbWD3bn7","text700":"KKKIm8Nv-zMPYWmockGoG","text600":"_3lElTxu2NoQRY2XDeVcCoC","text500":"_3WkNKNwGoZgzwUqnWp2B-v","text400":"VeEl7KuP9ZUxNC3rg_wfo","text300":"r3GKFuu-zkCvMJwkXiOHV","text200":"_2y04udg1a2acfEl51iwIxs","textParagraph":"_1Cf96IQL9Ff6S5sZ76D5dA","crimp":"_2lXgrzqwWNoQEHAjykje7i","trim":"G0YWAzxS0xgPXMP3_yIaB","flexCenter":"_23Gs5WGyhGkKUiHEee1J-V","hideTextOverflow":"AdvlL8ZtzS64-6eXvVaQA","marginPageMainContent":"_1HvEL6i-4U8SFvFGL7BHDV","formSection":"gwd1Fmde8mKAq4ArcqkN9","select":"-yagg7uvycvhtJb5UiZh2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageScorecard/styles.scss
// module id = 1323
// module chunks = 0